<template>
  <div
    class="pg-drawer-search-table-batch-number"
    :class="{ 'pg-drawer-search-table-batch-number__val': !!value && !disabled }"
  >
    <span class="pg-drawer-search-table-batch-number__text" :title="value">{{ value }}</span>
    <i
      class="ivu-icon-icon-pg-add pg-drawer-search-table-batch-number__add"
      v-if="!disabled"
      @click="handleClick"
    ></i>
    <i
      class="ivu-icon-icon-pg-qingchu pg-drawer-search-table-batch-number__clear"
      @click="clear"
    ></i>
    <PgDrawerSearchTableBatchNumberBasic
      ref="tableRef"
      v-model="visible"
      v-bind="$attrs"
      @on-ok="onOk"
    >
    </PgDrawerSearchTableBatchNumberBasic>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { ref, watch } from 'vue'
import PgDrawerSearchTableBatchNumberBasic from './drawer-search-table-batch-number-basic.vue'
import { beforValueOldActionProps, useBeforValueOldActions } from '../../../hooks/index'

const props = defineProps({
  value: String,

  //是否禁用
  disabled: Boolean,

  ...beforValueOldActionProps,
})

const emit = defineEmits(['input'])
const { beforeEmit } = useBeforValueOldActions({
  store: props.store,
  beforValueAction: props.beforValueAction,
  emit,
})

const visible = ref(false)
const handleClick = () => {
  visible.value = !visible.value
}
watch(
  () => props.value,
  () => {
    visible.value = false
  }
)

const tableRef = ref(null)
const onOk = (data) => {
  beforeEmit(data)
}

const clear = () => {
  beforeEmit(null)
}
</script>
<style lang="scss">
@import '../style/drawer-search-table-batch-number.scss';
</style>
